import React from "react";

const variants = {
  completed: "bg-success-subtle text-success-strong border-success-subtle",
  cached: "bg-accent-subtle text-accent-strong border-accent-subtle",
  pending_confirmation: "bg-subtle text-text-secondary border-border",
  pending_external: "bg-warning-subtle text-warning-strong border-warning-subtle",
  failed: "bg-danger-subtle text-danger-strong border-danger-subtle",
  confirmed: "bg-warning-subtle text-warning-strong border-warning-subtle",
};

const labels = {
  completed: "Completata",
  cached: "Da cache",
  pending_confirmation: "In attesa",
  pending_external: "In lavorazione",
  failed: "Fallita",
  confirmed: "Confermata",
};

export const StatusBadge = ({ status, cacheHit }) => {
  const display = cacheHit && status === "completed" ? "cached" : status;
  const cls = variants[display] || variants.pending_confirmation;
  return (
    <span
      data-testid={`status-badge-${display}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium ${cls}`}
    >
      {labels[display] || display}
    </span>
  );
};
